/**
 * @generated SignedSource<<5583c595d167c0804bb9d3673fc1ac68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMain_order$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainAccomodation_order" | "OrderEditMainContacts_order" | "OrderEditMainDocuments_order" | "OrderEditMainForm_order" | "OrderEditMainGeneral_order" | "OrderEditMainPassengers_order" | "OrderEditMainPayments_order" | "OrderEditMainServices_order" | "OrderEditMainTransport_order">;
  readonly " $fragmentType": "OrderEditMain_order";
};
export type OrderEditMain_order$key = {
  readonly " $data"?: OrderEditMain_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMain_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMain_order",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainForm_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainGeneral_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainPayments_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainPassengers_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainServices_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainAccomodation_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainTransport_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainContacts_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainDocuments_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "30a52a931c30c062bf0ff4c2d8d0e7df";

export default node;
